import { animate, useMotionValue } from "motion/react";
import { useEffect, useState } from "react";

type CountUpValueProps = {
  targetValue: number;
  suffix?: string;
  formatValue?: (value: number) => string;
  className?: string;
  intervalMs?: number;
};

export function CountUpValue({ targetValue, suffix = "", formatValue, className, intervalMs = 16 }: CountUpValueProps) {
  const [displayValue, setDisplayValue] = useState(0);
  const animatedValue = useMotionValue(0);

  useEffect(() => {
    const unsubscribe = animatedValue.on("change", latestValue => {
      setDisplayValue(Math.min(Math.round(latestValue), targetValue));
    });

    if (targetValue <= 0) {
      animatedValue.set(0);
      return unsubscribe;
    }

    const controls = animate(animatedValue, targetValue, {
      duration: Math.min(Math.max((targetValue * intervalMs) / 1000, 0.2), 3),
      ease: "easeOut",
    });

    return () => {
      controls.stop();
      unsubscribe();
    };
  }, [animatedValue, targetValue, intervalMs]);

  const formattedValue = formatValue ? formatValue(displayValue) : String(displayValue);

  return (
    <span className={className}>
      {formattedValue}
      {suffix}
    </span>
  );
}
